<template>
  <div class="password-container">
    <header>
      <span class="title">修改密码</span>
    </header>
    <div class="form">
      <div class="item">
        <span class="title"><span class="need">*</span>旧密码</span>
        <div class="right">
          <el-input v-model="oldPwd" placeholder="请输入内容" size="medium" type="password"></el-input>
        </div>
        <div class="err" v-if="err_o"><i class="el-icon-warning"></i>{{err_o}}</div>
      </div>
      <div class="item">
        <span class="title"><span class="need">*</span>新密码</span>
        <div class="right">
          <el-input v-model="newPwd" placeholder="请输入内容" size="medium" type="password"></el-input>
        </div>
        <div class="err" v-if="err_n"><i class="el-icon-warning"></i>{{err_n}}</div>
      </div>
      <div class="item">
        <span class="title"><span class="need">*</span>重复密码</span>
        <div class="right">
          <el-input v-model="repeatPwd" placeholder="请输入内容" size="medium" type="password"></el-input>
        </div>
        <div class="err" v-if="err_r"><i class="el-icon-warning"></i>{{err_r}}</div>
      </div>
      <div class="item">
        <span class="title"></span>
        <div class="right">
          <el-button type="primary" @click="preserve" size="medium" :disabled="!funAuth.includes(44)">确 定</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5'
import {TFParameter} from '@/common/js/constant.js'
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      defaultMsg: '<b>修改密码</b>',
      funAuth: [],
      oldPwd: '',
      newPwd: '',
      repeatPwd: '',
      err_o: '',
      err_n: '',
      err_r: ''
    }
  },
  mounted () {
    this.queryFchBtnAuth(({moduleId: 13}))
  },
  methods: {
    queryFchBtnAuth (params) {
      HTTPServer.queryFchBtnAuth(params, '').then((res) => {
        res.map((item, index) => {
          this.funAuth.push(item.func_id)
        })
      })
    },
    /** 修改密码 */
    preserve () {
      this.err_o = ''
      this.err_n = ''
      this.err_r = ''
      if (!this.oldPwd) {
        this.err_o = '旧密码不能为空'
        return
      }
      if (!this.newPwd) {
        this.err_n = '新密码不能为空'
        return
      }
      if (this.newPwd.length < 6 || this.newPwd.length > 13) {
        this.err_n = '密码格式由6-13位数字、字母、特殊符号组成'
        return false
      }
      if (!this.repeatPwd) {
        this.err_r = '确认密码不能为空'
        return
      }
      if (this.newPwd !== this.repeatPwd) {
        this.err_r = '两次输入的密码不相同'
        return
      }
      var jsondata = {'passWord': md5(md5(this.newPwd + TFParameter.TEAMFACEPWD)), 'pwd': md5(md5(this.oldPwd + TFParameter.TEAMFACEPWD))}
      HTTPServer.editPwd(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.password-container{
  .form{
    width: 500px;
    margin-top: 20px;
    .item{
      padding-bottom: 20px;
      overflow: hidden;
    }
    .title{
      float: left;
      width: 90px;
      line-height: 36px;
      font-size: 14px;
      color: #000;
      text-align: right;
      padding-right: 10px;
    }
    .need{
      font-size: 14px;
      color: rgba(255, 15, 15, 0.85);
      margin-right: 2px;
    }
    .right {
      width: calc(100% - 90px);
      margin-left: 90px;
      padding-left: 10px;
    }
    .err{
      font-size: 12px;
      color: #F5222D;
      line-height: 20px;
      padding-left: 100px;
      margin-bottom: -20px;
      i{
        font-size: 12px;
        margin-right: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/platform/password.vue